export default function parseOptions(stepId, content) {
  const contentItem = content.find(x => x.stepId === stepId);
  return contentItem ? contentItem.content : [];
}
